/* @flow @format */

import type { FetchResult, ApolloQueryResult } from 'apollo-client';

import type {
  CheckoutActivity,
  Collaboration,
  FinishActivity,
  GetContest,
  GetContests,
  GetScorings,
  TicketSignin,
  UpdateExamineeProfile,
} from './generated_types';
import { client } from './client';
import CHECKOUT_ACTIVITY from './mutation/CheckoutActivity.gql';
import COLLABORATION from './query/Collaboration.gql';
import FINISH_ACTIVITY from './mutation/FinishActivity.gql';
import GET_CONTEST from './query/GetContest.gql';
import GET_CONTESTS from './query/GetContests.gql';
import GET_SCORINGS from './query/GetScorings.gql';
import TICKET_SIGNIN from './mutation/TicketSignin.gql';
import UPDATE_EXAMINEE_PROFILE from './mutation/UpdateExamineeProfile.gql';

export type FetchAgreementInput = {
  +ticketSlug: string,
  +token: string,
  +termsOfUseVersion: string,
  +privacyPolicyVersion: string,
};

export type TicketSigninInput = {
  +ticketSlug: string,
  +token: string,
  +termsOfUseVersion: string,
  +privacyPolicyVersion: string,
};

export type CheckoutActivityInput = {
  +courseContentUid: string,
};

export type FinishActivityInput = {
  +courseContentUid: string,
  +point?: number,
};

type MutateResult<T> = Promise<FetchResult<T>>;
type QueryResult<T> = Promise<ApolloQueryResult<?T>>;

export type ApiType = {
  // quereis
  fetchContest: (uid: string) => QueryResult<GetContest>,
  fetchContests: () => QueryResult<GetContests>,
  fetchRankings: (courseContentUid: string) => QueryResult<GetScorings>,
  fetchAgreement: (input: FetchAgreementInput) => QueryResult<Collaboration>,
  // mutations
  ticketSignin: TicketSigninInput => MutateResult<TicketSignin>,
  updateUserProfile: ({ avatar: string, nickname: ?string }) => MutateResult<UpdateExamineeProfile>,
  checkoutActivity: CheckoutActivityInput => MutateResult<CheckoutActivity>,
  finishActivity: FinishActivityInput => MutateResult<FinishActivity>,
};

const api: ApiType = {
  fetchContest: uid => {
    const variables: { [string]: any } = { uid };
    return client.query({ query: GET_CONTEST, variables });
  },
  fetchContests: () => client.query({ query: GET_CONTESTS }),
  fetchRankings: courseContentUid => {
    const variables: { [string]: any } = { where: { courseContentUid } };
    return client.query({ query: GET_SCORINGS, variables });
  },
  fetchAgreement: where => {
    const variables: { [string]: any } = { where };
    return client.query({ query: COLLABORATION, variables });
  },
  ticketSignin: input => client.mutate({ mutation: TICKET_SIGNIN, variables: { input } }),
  updateUserProfile: input => client.mutate({ mutation: UPDATE_EXAMINEE_PROFILE, variables: { input } }),
  checkoutActivity: input => client.mutate({ mutation: CHECKOUT_ACTIVITY, variables: input }),
  finishActivity: input => client.mutate({ mutation: FINISH_ACTIVITY, variables: { input } }),
};

export default api;
